import { NgModule } from '@angular/core';
import { MxPagesRoutingModule } from './mx.pages-routing.module';


@NgModule({
  imports: [MxPagesRoutingModule],
  exports: [],
})
export class MxPagesModule {}
